/**
 * ImageUnavailable.jsx
 * Created by Destin Frasier on 8/11/17.
 */

import React from 'react';
import { IconPhotoUnavailable } from './icons/Icons';

const ImageUnavailable = () => (
    <div className="rec-image-unavailable-wrap">
        <figure>
            <IconPhotoUnavailable />
            <figcaption>Photo Unavailable</figcaption>
        </figure>
        <img src={`${process.env.CDN}/img/image-unavailable.jpg`} alt="Unavailable" aria-label="Unavailable" />
    </div>
);

export default ImageUnavailable;
